module.exports = __webpack_public_path__ + "img/card-llm-badge.67e2aa3d.png";